import { Component, OnInit, Inject, ViewChild, TemplateRef } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { IAuthService } from "src/app/core/services/api/contracts/auth-service";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";

import { IWService } from "../../../../core/services/iw.service";
import { IndexComponent } from "src/app/modules/landing-page/pages/index/index.component";
import { Organization } from "../../../../core/models/organization-model";
import { QrLoginComponent } from "../../qr-login/qr-login.component";

@Component({
  selector: "login-index",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.css"],
})
export class LoginIndexComponent implements OnInit {
  public loginForm: FormGroup;
  public submitting: boolean = false;
  public showSpinner: boolean = false;
  public badCredentials: boolean = false;
  public selectOrganization: boolean = false;
  @ViewChild('content') private modalContent: TemplateRef<IndexComponent>;
  private modalRef: NgbModalRef;
  organizations: Organization[];
  form: FormGroup;
  submitted: boolean = false;
  id: number = null;
  base64String: any;
  did: any;
  data: { familyName: string, givenName: string, id: string };

  constructor(
    @Inject("IAuthService") private authService: IAuthService,
    private modalService: NgbModal,
    public translate: TranslateService,
    public iwService: IWService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,

  ) { }

  async ngOnInit() {

    this.form = this.formBuilder.group({
        organization: ["", Validators.required]
    });
    this.form.get('organization').setValue(0);

    this.route.queryParams.subscribe(params => {
        const data: any = params['userByOrganization'];
        if (data == -1) {

          this.openModal();
        }

    });

  }

  async extrSign() {
    await this.iwService.extrSign();
  }

  async onSubmit() {
  const modalRef = this.modalService.open(QrLoginComponent, {
    backdrop: "static",
    keyboard: false,
    centered: true,
    size: "lg",
  });

  modalRef.componentInstance.data = this.base64String;

  this.submitting = true;
  this.showSpinner = true;

  modalRef.result.then(async resultvc => {
    if (!resultvc || resultvc.success === false) {
      this.showSpinner = false;
      this.submitting = false;
      return;
    }

    this.data = resultvc.data;
    this.did = this.data.id;

    try {
      let result = await this.authService.loginVC(this.did, this.id);

      if (result.organizations.length > 1) {
        this.organizations = result.organizations;
        await this.openModal();
      }

      this.submitting = false;
      this.showSpinner = false;

    } catch (ex) {
      console.error('Error en loginVC:', ex);
      this.submitting = false;
      this.showSpinner = false;
    }

  }).catch((reason) => {
    console.log('Modal cerrado sin valor devuelto', reason);
    this.showSpinner = false;
    this.submitting = false;
  });
}

  async openModal() {
    this.modalRef = this.modalService.open(this.modalContent);
  }

  close() {
    this.modalRef.close()
  }

  async select() {

    this.id = this.form.controls['organization'].value;
    await this.authService.loginVC(this.did,this.id);
    this.modalRef.close();

  }

  dismiss() {
    this.modalRef.dismiss()
  }

  get f() {
    return this.form.controls;
  }

}
